export const featureFlags = {
    FULLSIZE_RESERVATION_MODAL: {
        description: '(#2470) Fullscreen modal pro editaci rezervace',
        defaultValue: false,
    },
    // Add more feature flags here
} as const;

export type Feature = keyof typeof featureFlags;
